// import moment from 'moment';
import moment from 'moment-timezone';

import React from 'react';
import { useAppSelector } from '../../hooks';
import { selectAuth } from '../../features/authSlice';

interface Props {
    formattedDate?: string;
    format?: string;
    useBrowserTimeZone?: boolean;
}

const getBrowserTimeZone = (): string => {
    try {
        return (
            (typeof Intl !== 'undefined' && Intl.DateTimeFormat().resolvedOptions().timeZone) ||
            moment.tz.guess() ||
            'UTC'
        );
    } catch {
        return moment.tz.guess() || 'UTC';
    }
};

const DateTimeComp: React.FC<Props> = ({
    formattedDate,
    format = 'MM-DD-YYYY hh:mm A',
    useBrowserTimeZone = true,
}) => {
    const { timeZone } = useAppSelector(selectAuth);
    
    // Check current timezone from browser (fallback to auth timezone or UTC)
    const browserTimeZone = getBrowserTimeZone();
    const activeTimeZone = useBrowserTimeZone
        ? (browserTimeZone || timeZone || 'UTC')
        : (timeZone || browserTimeZone || 'UTC');

    const parsedDate = formattedDate
        ? moment.utc(formattedDate) // Parses date as UTC from backend
        : null;

    const formattedDateTimeString = parsedDate && parsedDate.isValid()
        ? parsedDate.tz(activeTimeZone).format(format)
        : (formattedDate || '');

    return (
        <>{formattedDateTimeString}</>
    );
}

export default DateTimeComp;
